export type GenerateStartEndFromYmdListsInput = {
  ymdList?: string[];
  ymdComparisonList?: string[];
  startDate?: string;
  endDate?: string;
  startComparisonDate?: string;
  endComparisonDate?: string;
};

export type GenerateStartEndFromYmdListsOutput = {
  ymdList: string[] | undefined;
  ymdComparisonList: string[] | undefined;
  startDate: string | undefined;
  endDate: string | undefined;
  startComparisonDate: string | undefined;
  endComparisonDate: string | undefined;
};

/**
 * ymdList / ymdComparisonList から API 用の start/end 系フィールドを生成する。
 * 期間順リストの先頭・末尾を優先し、欠ける場合は引数の start/end を使う（比較側も同様）。
 */
export const generateStartEndFromYmdLists = (
  input: GenerateStartEndFromYmdListsInput
): GenerateStartEndFromYmdListsOutput => ({
  ymdList: input.ymdList,
  ymdComparisonList: input.ymdComparisonList,
  startDate: input.ymdList?.at(0) ?? input.startDate,
  endDate: input.ymdList?.at(-1) ?? input.endDate,
  startComparisonDate:
    input.ymdComparisonList?.at(0) ?? input.startComparisonDate,
  endComparisonDate: input.ymdComparisonList?.at(-1) ?? input.endComparisonDate,
});
